import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { cdnUrl } from "@Utils/cdnHelper";
import H3Image from '@Uilib/h3Image';
import './style.scss';

/**
 *
 */
class Loader extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  /**
   *
   * @return {JSX.Element}
   */
  render() {
    const { user, isAuthenticated, getUserProfileLoading } = this.props;
    return (
      <Fragment>
        <div className="primary-loader__wrapper">
          <div>
            <H3Image src={cdnUrl("loader.gif", "images")} className="primary-loader__image" />
            <br />
            Loading...
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ UserReducers }) => ({
  user: UserReducers.user,
  isAuthenticated: UserReducers.isAuthenticated,
  getUserProfileLoading: UserReducers.getUserProfileLoading
});

const mapDispatchToProps = () => ({
});

Loader.propTypes = {
  isAuthenticated: PropTypes.bool,
  user: PropTypes.any,
  getUserProfileLoading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Loader));
